declare const process: {
  env: {
    VITE_API_URL?: string
    VITE_CONFIG_URL?: string
    VITE_URL?: string
  }
}

export const API_URL = process.env.VITE_API_URL
export const CONFIG_URL = process.env.VITE_CONFIG_URL
export const APP_URL = process.env.VITE_URL
